import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import classes from './ChildDialogContainer.module.scss';
const ChildDialogContainer = ({ title, content, action }) => {
    return (_jsxs("div", { className: classNames(classes.container), children: [title && _jsx("div", { className: classes.title, children: title }), content && _jsx("div", { className: classes.content, children: content }), action && _jsx("div", { className: classes.action, children: action })] }));
};
export default ChildDialogContainer;
